._panel-container_jqpbo_1 {
  height: 526px;
  display: grid;
  grid-template-columns: 48px 1fr; }
  ._panel-container_jqpbo_1 ._tab-header_jqpbo_5 {
    padding: 12px 0 0 24px; }
  ._panel-container_jqpbo_1 ._text-tab_jqpbo_7 {
    padding: 12px 24px; }
    ._panel-container_jqpbo_1 ._text-tab_jqpbo_7:last-child {
      padding-bottom: 0; }
    ._panel-container_jqpbo_1 ._text-tab_jqpbo_7 ._attr-container_jqpbo_11 {
      padding: 18px 0;
      display: grid;
      gap: 6px; }
    ._panel-container_jqpbo_1 ._text-tab_jqpbo_7 ._decoration-select_jqpbo_15 {
      display: grid;
      grid-template-columns: repeat(2, 62px);
      gap: 10px; }
    ._panel-container_jqpbo_1 ._text-tab_jqpbo_7 ._align-select_jqpbo_19 {
      display: grid;
      grid-template-columns: 96px 28px;
      gap: 10px; }
      ._panel-container_jqpbo_1 ._text-tab_jqpbo_7 ._align-select_jqpbo_19 ._direction-button_jqpbo_23 {
        position: relative;
        top: 3px; }
    ._panel-container_jqpbo_1 ._text-tab_jqpbo_7 ._radio-btn_jqpbo_26 {
      display: grid;
      gap: 12px;
      margin-top: 12px; }
  ._panel-container_jqpbo_1 ._color-tab_jqpbo_30 ._media-image_jqpbo_30 {
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50%;
    background-color: #f0f0f0; }
  ._panel-container_jqpbo_1 ._color-tab_jqpbo_30 ._change-media-btn_jqpbo_36 {
    padding: 6px 18px;
    margin: 12px auto;
    display: flex; }
  ._panel-container_jqpbo_1 ._color-tab_jqpbo_30 .composite-toggle-switch .control-switch > .symbol-switch {
    margin-left: 10px; }

._font-theme-label_jqpbo_43 {
  display: flex;
  justify-content: space-between; }
